var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 36,
    viewBox: "0 0 36 36",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.7432 24.5107c0 1.5245.8066 2.3311 2.3173 2.3311h6.3711c1.5108 0 2.3174-.8135 2.3174-2.3311v-1.2578h1.128c1.5107 0 2.3173-.8203 2.3173-2.3379v-5.291c0-.9502-.205-1.5586-.7656-2.1396l-3.3769-3.4385c-.5401-.54688-1.1827-.76563-2.0235-.76563h-2.5293c-1.5039 0-2.3105.81353-2.3105 2.33103v1.2647h-1.128c-1.5107 0-2.3173.8135-2.3173 2.331zm10.2812-7.2119-3.6572-3.705c-.4922-.5059-.9365-.6768-1.6133-.711v-1.1279c0-.5879.294-.9092.916-.9092h2.7139v3.0488c0 .8955.5058 1.3946 1.3945 1.3946h2.8506v5.4892c0 .5879-.3008.9092-.9228.9092h-.9571v-2.3652c0-.9502-.1299-1.4219-.7246-2.0235zm-.4033-3.5752v-2.3037l2.5977 2.6319h-2.2696c-.2324 0-.3281-.1026-.3281-.3282zm-8.3125 10.6436v-9.0166c0-.5879.2939-.9092.916-.9092h1.9688v3.5274c0 1.0937.5332 1.6132 1.6132 1.6132h3.377v4.7852c0 .5947-.3008.916-.9229.916h-6.0361c-.6221 0-.916-.3213-.916-.916zm4.6279-6.1045c-.2871 0-.417-.1299-.417-.4238v-3.1309l3.5 3.5547z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.02e509766e71576a214341a49978fe4c.svg";
export { ForwardRef as ReactComponent };